"use strict";

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.search.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.regexp.replace.js");

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _constants = require("@evdy/web-redux/src/constants");

var _querystring = _interopRequireDefault(require("querystring"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "*",
    onEnter: function onEnter(_ref) {
      var _ref$location = _ref.location,
          pathname = _ref$location.pathname,
          search = _ref$location.search;
      var formatSearch = search.charAt(0) === '?' ? search.slice(1) : search;

      var qs = _querystring.default.parse(formatSearch);

      if (!qs.redirects) {
        qs.redirects = 1;
      } else {
        qs.redirects++;
      }

      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
        if (qs.redirects > 1) {
          window.location.replace("".concat(_constants.API_URL, "/404"));
        } else {
          window.location.replace("".concat(_constants.API_URL).concat(pathname, "?").concat(_querystring.default.stringify(qs)));
        }
      }
    }
  });
};

exports.default = _default;